export default __webpack_public_path__ + "static/media/report_icon.2b5ee9b4.svg";